import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import { set_auth, set_add_step } from "../redux/Branch/branchAction";
import { notify } from "react-notify-toast";
import db from "../firebase";
import { useHistory } from "react-router";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
}));
export default function AuthSetup({ id, edit }) {
  const classes = useStyles();
  const [bEmail, setBEmail] = useState("");
  const [password, setPassword] = useState("");
  const [branch, setBranch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      getdata(id);
    } else {
      setLoading(false);
    }
  }, []);
  const getdata = async (id) => {
    setLoading(true);
    const doc = await db.collection("users").where("of", "==", id).get();
    console.log(doc.size);
    doc.forEach((data) => {
      console.log(data.data(), "ffff");
      setBEmail(data.data().email);
      setPassword(data.data().password);
      setName(data.data().name);

      setLoading(false);
    });
    setLoading(false);
  };
  const submit = async () => {
    setLoading(true);
    if (password != password2) {
      notify.show("Both passwords are not the same!", "warning");
      setLoading(false);
      return;
    }
    if (bEmail === "" || password === "" || password2 === "" || name === "") {
      notify.show("Fill all fields", "warning");
      setLoading(false);
      return;
    }
    if (edit) {
      let data = await db.collection("users").where("of", "==", id).get();
      if (data.size === 0) {
        await db.collection("users").add({
          email: bEmail,
          of: id,
          password: password,
          name: name,
          role: "Branch",
        });
        setLoading(false);
        notify.show("Auth updated Successfully!", "success");
        return;
      }
      data.forEach(async (doc) => {
        await db.collection("users").doc(doc.id).update({
          email: bEmail,
          of: id,
          password: password,
          name: name,
          role: "Branch",
        });
      });
      notify.show("Auth updated Successfully!", "success");

      history.push({
        pathname: edit
          ? `/branch/edit/${id}/location`
          : `/branch/add/location/`,
        state: { id },
      });
      return;
    }
    await db.collection("users").add({
      email: bEmail,
      password: password,
      role: "Branch",
      of: id,
      name: name,
    });
    setLoading(false);

    notify.show("Auth updated Successfully!", "success");
    dispatch(
      set_auth({
        auth: {
          email: bEmail,
          password: password,
          name: name,
        },
      })
    );
    history.push({ pathname: "/branch/add/location" });
  };
  return (
    <div>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
        <div className={classes.text}>Loading</div>
      </Backdrop>
      <h2>Branch Authentication</h2>

      <div className="add_form_control-select">
        <p>
          <strong>Brand Name: </strong>
          {JSON.parse(localStorage.getItem("Ubytes")).brandName}
        </p>
      </div>
      <div className="input_group">
        <label htmlFor="">Name:</label>
        <input
          className="form_input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="input_group">
        <label htmlFor="">Email:</label>
        <input
          className="form_input"
          type="text"
          value={bEmail}
          onChange={(e) => setBEmail(e.target.value)}
        />
      </div>
      <div className="input_group">
        <label htmlFor="">Password:</label>
        <input
          className="form_input"
          type="text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className="input_group">
        <label htmlFor="">Confirm Password</label>
        <input
          className="form_input"
          type="text"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
        />
      </div>
      <div className="mt-4">
        <button type="submit" className="btn_light_blue" onClick={submit}>
          Save Changes
        </button>
      </div>
    </div>
  );
}
